( function( window, document, undefined ) {

  'use strict';

  var $ = window.jQuery
    , console = window.console || { log: function() { } }
    , rmsso = false
    , commentSection = $( '.vodl-comment-section' )
    , commentFormWrapper = $( '.vodl-comment-section__form-wrapper' )
    , commentsWrapper = $( '.vodl-comment-section__comments-wrapper' )
    , commentsSectionLogin = document.querySelector('.vodl-comment-section__login')
    , reportCommentFormWrapper = commentSection.find( '.vodl-comment-report__form-wrapper' )
    , reportCommentsModal = commentSection.find( '.vodl-comment-report--modal' )
    , reportSelect
    , textarea = null
    , reportTextarea = null
    , charCounter = null
    , usernameWrapper = $( '.vodl-comment-section__username-wrapper' )
    , usernameInput
    , errorNode = null
    , reportErrorNode = null
    , anonMode = true
    , answerNotificationCheckbox = null
    , submitButton = null
    , submitReportButton = null
    , answerButtons = null
    , reportButtons = null
    , ratePositiveIcons = null
    , rateNegativeIcons = null
    , answerCancelButton = null
    , reportCancelButton = null
    , reportSelectedData = null
    , reportedCommentClass = 'vodl-comment__report-comment--disabled'
    , postId = false
    , commentsDisabled = false
    , config = null
    , localStorageComment = null
    , comment_registration = false
    , premiumContent = false
    , storage = {}
      ;

  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch(e) {
    storage = {
      get: function() {
        return null;
      },
      set: function() {
        return false;
      },
      remove: function() {
        return;
      }
    };
  }

  /**
   * Inits the comments: find all needed DOM elements, reset values, load config, load comments and assing event handlers
   * @param  {boolean} [keepForm=false] optional parameter, if set to true form data is not cleared, default: false
   */
  function init( keepForm ) {
    keepForm = keepForm || false; //parameter is optional and defaults to false

    //there is no comment section, bail
    if ( 0 === commentSection.length ) {
      return;
    }

    //if there is no readable postId, bail
    postId = commentSection.data('comment-post-id') || false;
    if ( !postId ){
      return;
    }

    //if comments are disabled, bail
    commentsDisabled = commentSection.data('comments-disabled') || false;
    if ( commentsDisabled ) {
      return;
    }

    //collect some more element nodes, at this point we assume they exist
    textarea = commentFormWrapper.find( 'textarea' ); //the comment textarea
    reportTextarea = reportCommentFormWrapper.find( 'textarea' ); //the comment textarea
    charCounter = commentFormWrapper.find( '.vodl-comment-section__char-count' ); //the char counter
    answerNotificationCheckbox = commentFormWrapper.find( '#vodl-comment-section__option-email-notification' ); //the checkbox for answer notifications
    usernameInput = $( '#vodl-comment-section__input-name' ); //the input field for the anonymous user name
    submitButton = commentFormWrapper.find( '.vodl-comment-section__submit button' ); //the submit button
    submitReportButton = reportCommentFormWrapper.find( '.vodl-comment-report__submit' ); //the submit button
    errorNode = commentFormWrapper.find( '.vodl-comment-section__error' ); //the node for error messages
    reportErrorNode = reportCommentFormWrapper.find( '.vodl-comment-report__error' );
    reportSelect = reportCommentFormWrapper.find('.vodl-select-report__current');
    premiumContent = document.querySelector('.vodl-region-article__premium-content');

    //disable submit button until comments are fully loaded
    submitButton.prop( 'disabled', true );

    //clear the form input fields if keepForm is not true
    if ( ! keepForm ) {
      textarea.val( '' );
      reportTextarea.val('');
      usernameInput.val( '' );
      errorNode.empty();
      reportErrorNode.empty();
      handleAnswerCancelClick();
      handleReportCancelClick();
    }

    //load configuration/localization
    initConfig();

    //if the user is banned, hide the comment section
    const userStatus = window.RussMedia.Utils.LocalStorage.get('user-status');

    if (userStatus?.commentBan) {
      hideCommentSection(userStatus.commentBan);
      return;
    }

    //load the comments and...
    loadComments().then(
      function() {
        moveCommentAds();
        filterComments();
      },
      function() {
        console.log('loading comments failed');
      }
    ).always(
      function() {
        //... check the user login status afterwards
        window.RussMedia = window.RussMedia || {};
        rmsso = window.RussMedia.SSO || false;

        if (!rmsso) {
          console.log('SSO API absent :(');
          return false;
        }

        //if the user is logged in...
        rmsso.isLoggedInAsync().then(
          function() {
            //... hide the username input field...
            usernameWrapper.hide();
            anonMode = false;
          },
          function() {
            if (commentsSectionLogin !== null) {
              commentsSectionLogin.style.display = 'flex';
              commentsWrapper[0].classList.add('blur');

              const ua = window.navigator.userAgent;
              const isIE = /MSIE|Trident/.test(ua);
              if (isIE) {
                commentsWrapper[0].style.display = 'none';
              }
            }

            // if comment registration is required
            if (comment_registration) {
              usernameWrapper.hide();
            } else {
              //... otherwise show it
              usernameWrapper.show();
            }
            anonMode = true;
          }
        ).always(
          function() {
            //assign event handlers

            initEventHandlers();
            disableReportedComments();
            if (comment_registration) {
              localStorageAddComment();
            }
            // update the login/logout status in the header
            rmsso.UI.checkLoginStatus();
          }
        );
      }
    );
  }

  /**
       * loads the configuraton from an inline json in the DOM and puts the result into config
       */
  function initConfig() {
    var commentConfig = $( "#vodl-comments-cfg" );
    if ( commentConfig.length > 0 ) {
      config = $.parseJSON( commentConfig.html() ) || {};
    }
  }

  /**
       * Read a localized string from sconfig.localization
       * @param  {string} prop the property we want to get
       * @return {string}      the localized string
       */
  function getLocalization( prop ) {
    var i18n = config.localization || {};
    var value = i18n[ prop ] || '';
    return value;
  }

  /**
       * Assign event handlers to buttons etc.
       */
  function initEventHandlers() {

    //the answer buttons below each comment
    answerButtons = commentsWrapper.find( '.vodl-comment__answer-comment' );
    answerButtons.off( 'click' ).on( 'click', handleAnswerClick );

    //the report buttons below each comment
    reportButtons = commentsWrapper.find( '.vodl-comment__report-comment' );
    reportButtons.off( 'click' ).on( 'click', handleReportClick );

    //the cancel (X) button inside the comment form to cancel answer mode
    answerCancelButton = commentFormWrapper.find( '.vodl-comment-section__close-form' );
    answerCancelButton.off( 'click' ).on( 'click', handleAnswerCancelClick );

    //the cancel (X) button inside the comment form to cancel report mode
    reportCancelButton = reportCommentFormWrapper.find( '.vodl-comment-report__close-form' );
    reportCancelButton.off( 'click' ).on( 'click', handleReportCancelClick );

    //re-enable form submit button and assign click event handler
    submitButton.prop( 'disabled', false );
    submitButton.off( 'click' ).on( 'click', handleCommentSubmit );

    submitReportButton.prop( 'disabled', false );
    submitReportButton.off( 'click' ).on( 'click', handleReportSubmit );

    //event handler for keeping track of the number of characters in the comment input textarea
    textarea.off( 'keyup' ).on( 'keyup', updateCharCount );
    textarea.off( 'keydown' ).on( 'keydown', updateCharCount );

    //the rating buttons below each comment
    ratePositiveIcons = commentsWrapper.find( '.vodl-comment__rating-up-icon' );
    rateNegativeIcons = commentsWrapper.find( '.vodl-comment__rating-down-icon' );
    ratePositiveIcons.off( 'click' ).on( 'click', function() {
      var currentButton = $( this );
      handleRateClick( currentButton, 'positive' );
    } );
    rateNegativeIcons.off( 'click' ).on( 'click', function() {
      var currentButton = $( this );
      handleRateClick( currentButton, 'negative' );
    } );


    //listen to login actions, so we can re-init the comments without page reload
    $( window ).on( 'login-status-change', function( e, value ) {
      if( 'SSO_ssoLoginSuccessMessage' ===  value ) {
        init( true );
      }
    } );

  }

  /*  Event handlers  */

  /**
   * Handles the submit button click. Does some basic validation and checks if the user is logged in. If everything is OK, triggers postComment()
   * @param  {eventObject} e jQuery event object
   * @return {boolean}   returns false on failure
   */
  function handleCommentSubmit( e ) {
    //disable default events
    e.preventDefault();

    //remove the comment from local storage
    localStorage.removeItem( 'comment_data' );

    //collect data: comment, placeholder text, username field
    var comment = $.trim( textarea.val() )
      , commentPlaceholder = $.trim( textarea.attr( 'placeholder' ) )
      , anonUsername = $.trim( usernameInput.val() )
        ;

    //some very basic validation
    if ( ( '' === comment ) || ( comment  === commentPlaceholder ) ){
      showError( getLocalization( 'error__commentEmpty' ) );
      return false;
    }

    if ( comment_registration && anonMode ) {
      var data = {
        comment_post_id: postId,
        comment_parent: commentFormWrapper.data( 'comment-parent' ) || false,
        comment_content: $.trim( textarea.val() ),
        notify_on_answer: answerNotificationCheckbox.is( ':checked' ),
      };

      localStorage.setItem( 'comment_data', JSON.stringify( data ) );

      return notificationAnonymousComment();

    } else if( anonMode && ( '' === anonUsername || anonUsername.length < 6 ) ) {
      showError( getLocalization( 'error__anonUsernameTooShort' ) );
      return false;
    }

    //check login status, if user is logged in...
    window.RussMedia = window.RussMedia || {};
    rmsso = window.RussMedia.SSO || false;

    if ( ! rmsso ) {
      console.log( 'SSO API absent :(' );
      return false;
    }

    // disable form elements (mainly submit button) before check login status
    // to avoid double clicks on submit button.
    processing( true );

    rmsso.isLoggedInAsync().then(
      function() {
        // trigger  track event for comment when user is logged in
        trackGTMComments();
        //... trigger postComment WITHOUT passign an anonymous username
        postComment();
      },
      function() {
        //... otherwise trigger postComment WITH passign an anonymous username
        //check if username exist
        rmsso.checkUserExistsAsync( anonUsername ).then(
          function() {
            // trigger track event for comment from anonymous username
            trackGTMComments();
            //on success, user can comment
            postComment( anonUsername );
          },
          function() {
            //on failure, nickname already in use
            showError( getLocalization('error__anonUsernameExist') );
            return false;
          }
        ).always(
          function() {
            // always disable processing indicator when done
            processing( false );
          }
        );
      }
    ).always(
      function() {
        // update the login/logout status in the header
        rmsso.UI.checkLoginStatus();
      }
    );

  }

  function showLoginModal() {
    $('.vodl-login-label__login:first').click();
    const notification = $('.vodl-notification--comment');
    notification.parent().remove();
  }

  function notificationAnonymousComment() {
    var deferred = $.Deferred()
      , url = '/api/nnp/get_anonymous_comment';
    ;
    var loadingIndicator = commentFormWrapper.find( '.vodl-comment-section__loading' );

    let mediaQuery = window.matchMedia( '(min-width: 37rem)' );
    let device = 'desktop';

    if ( !mediaQuery.matches ) {
      device = 'mobile';
    }

    loadingIndicator.show();
    $.ajax( {
      type: 'GET'
      , url: url
      ,data:{device:device}
    } ).then(
      function( result ) {
        $(document.body).append( result );
        const notification = $('.vodl-notification--comment');
        notification.parent().css('display', 'flex');
        loadingIndicator.hide();
        const vodl_comment_login_btn = $('#vodl-comment-login');
        vodl_comment_login_btn.off( 'click' ).on( 'click', showLoginModal );

        const close = notification.find('.vodl-notification__close');
        close.on('click', function(){
          notification.parent().remove();
        });

        deferred.resolve();
      },
      function( jqXHR, textStatus, errorThrown ) {
        //failure, reject promise
        console.log( 'Error loading comment anonymous popup: ' +  errorThrown );
        loadingIndicator.hide();
        deferred.reject();
      }
    );

    return deferred.promise();
  }

  function handleReportSubmit( e ) {
    //disable default events
    e.preventDefault();

    //collect data: comment, placeholder text, username field
    reportSelectedData = $.trim(reportSelect.attr('data-report-slug') );

    //some very basic validation
    if ( '' === reportSelectedData ){
      showReportError( getLocalization( 'report__missingReason' ) );
      return false;
    }

    //check login status, if user is logged in...
    window.RussMedia = window.RussMedia || {};
    rmsso = window.RussMedia.SSO || false;

    if ( ! rmsso ) {
      console.log( 'SSO API absent :(' );
      return false;
    }

    rmsso.isLoggedInAsync().then(
      function() {
        //... trigger reportComment WITHOUT passign an anonymous username
        reportComment();
      },
      function() {
        //... otherwise trigger postComment WITH passign an anonymous username
        reportComment();
      }
    ).always(
      function() {
        // update the login/logout status in the header
        rmsso.UI.checkLoginStatus();
      }
    );

  }

  /**
   * Handles click events on the answer buttons below each comment. Will move the comment form below the comment to be answered to.
   * @param  {eventObject} e jQuery event object
   */
  function handleAnswerClick( e ) {
    e = e || false;
    if ( e ) {
      e.preventDefault();
    }

    var currentButton = $( this ); //the clicked answer button
    var commentId = currentButton.data( 'comment-id' ) || false; //the comment ID to answer to
    if ( ! commentId ) {
      //bail if we could not determine the commentId to answer to.
      return;
    }
    var commentTargetContainer = currentButton.parents( '.vodl-comment' ); //the container div, where we need to append the form to

    commentFormWrapper.data( 'comment-parent', commentId ); //set the commentId as data attribute of the form to be able to pass it the the comment API when posting the answer.
    commentFormWrapper.appendTo( commentTargetContainer ); //append the comment form to the comment where the user wants to answer to

  }

  const getReportedCommentIds = () => {
    let reportedCommentIds = [];
    reportedCommentIds = storage.get('reported-comments') || [];

    return reportedCommentIds;
  };

  /**
   * Disables report buttons of each comment that has been reported by this user already.
   */
  const disableReportedComments = () => {
    if (!reportButtons || reportButtons.length === 0) {
      return;
    }

    let reportedCommentIds = getReportedCommentIds();

    reportButtons.toArray().forEach((button) => {
      if (!button) {
        return;
      }

      if (button.classList.contains(reportedCommentClass)) {
        return;
      }

      const commentId = button.getAttribute('data-comment-id');
      if (reportedCommentIds.includes(parseInt(commentId))) {
        button.classList.add(reportedCommentClass);
      }
    });
  };

  /**
   * Handles click events on the answer buttons below each comment. Will move the comment form below the comment to be answered to.
   * @param  {eventObject} e jQuery event object
   */
  function handleReportClick( e ) {
    e = e || false;
    if ( e ) {
      e.preventDefault();
    }

    var currentButton = $( this ); //the clicked answer button
    var commentId = currentButton.data( 'comment-id' ) || false; //the comment ID to answer to
    if ( ! commentId ) {
      //bail if we could not determine the commentId to answer to.
      return;
    }

    let reportedCommentIds = getReportedCommentIds();
    if (reportedCommentIds.includes(commentId)) {
      // bail if the user has already reported this comment
      return;
    }

    var commentTargetContainer = currentButton.parents( '.vodl-comment' )
      , commentContentContainer = commentTargetContainer.find('.vodl-comment__comment')
      , commentContent = $.trim( commentContentContainer.text() );
    reportCommentFormWrapper.data( 'comment-content', commentContent);  //set comment content.
    reportCommentFormWrapper.data( 'comment-parent', commentId ); //set commentID.
    $(document.body).append(reportCommentsModal); //Append modal to body
    reportCommentsModal.css('display','flex');
  }

  /**
   * Handle click on the cancel (X) button when answering to an existing comment. Will reset the form to its top position.
   * @param  {eventObject} e jQuery event object
   */
  function handleAnswerCancelClick( e ) {
    e = e || false;
    if ( e ) {
      e.preventDefault();
    }
    //reset the comment-parent data
    commentFormWrapper.data( 'comment-parent', false );
    //move the form back directly below the comment headline element
    commentFormWrapper.insertAfter( '.vodl-comment-section__headline' );
  }

  /**
   * Handle click on the cancel (X) button when answering to an existing comment. Will reset the form to its top position.
   * @param  {eventObject} e jQuery event object
   */
  function handleReportCancelClick( e ) {
    e = e || false;
    if ( e ) {
      e.preventDefault();
    }
    //reset the comment-parent data
    reportCommentFormWrapper.data( 'comment-parent', false );
    //remove the report form
    reportCommentsModal.hide();
  }

  /**
   * Handle the click on a rate button
   * @param  {Object} currentButton jQuery object representing the clicked button
   * @param  {string} type          rating type, 'positive' or 'negative'
   */
  const handleRateClick = ( currentButton, type ) => {

    let commentId = currentButton.data( 'comment-id' ) || false;
    if( ! commentId ) {
      return;
    }

    trackClick();

    rateComment( commentId, type ).then(
      ( result ) => {
        updateRatings( result, type );
      },
      ( result ) => {
        // fail (almost) silently
        console.log( result );
      }
    ).always(
      () => {
        disableRatingButtons( commentId );
      }
    );
  };

  /* get/post data */

  /**
   * Rate a comment via the API
   * @param  {number} commentId Id of the comment to rate
   * @param  {string} type      Rating type, 'positive' or 'negative'
   * @return {Promise}          A promise object
   */
  function rateComment( commentId, type ) {
    var deferred = $.Deferred();

    var data = {
      comment_id: commentId,
      rate_type: type
    };

    $.ajax( {
      type: 'POST'
      , dataType: 'json'
      , url: '/api/nnp/rate_comment'
      , data: data
    } ).then(
      function( result ) {
        //request success, but let's check the result
        result.status = result.status || false;
        if( 'ok' !== result.status ) {
          deferred.reject( result );
          return deferred.promise();
        }

        result.is_legal_vote = result.is_legal_vote || false;
        if( ! result.is_legal_vote ) {
          deferred.reject( result );
          return deferred.promise();
        }

        deferred.resolve( result );

      },
      function( jqXHR, textStatus, errorThrown ) {
        //failure
        console.log( 'Error rating comment: ' +  errorThrown );
        deferred.reject( false );
        return deferred.promise();
      }
    );

    return deferred.promise();
  }


  /**
   * Post a comment via the API
   * @param  {string|boolean} [anonymousNick=false] If set the anonymousNick will be passed to the API for anonymous commenting, default: false
   */
  function postComment( anonymousNick ) {

    //parameter is optional
    anonymousNick = anonymousNick || false;

    //indicate processing
    processing( true );

    //create data object for the API call
    var data = {
      comment_post_id: postId,
      comment_parent: commentFormWrapper.data( 'comment-parent' ) || false,
      comment_content: $.trim( textarea.val() ),
      notify_on_answer: answerNotificationCheckbox.is( ':checked' ),
    };
    //if set, add anonymousNick to the data
    if (anonymousNick) {
      data.comment_author = anonymousNick;
      post_comment__api_call(data);
    } else {
      rmsso.getUserAsync().then(function (user) {
        data.sso_id = user.ssoId;
      }).always(
        function () {
          post_comment__api_call(data);
        }
      );
    }
  }

  /**
   * outsource api call.
   * @param {object} data
   */
  function post_comment__api_call(data) {
    // call the API.
    $.ajax( {
      type: 'POST'
      , dataType: 'json'
      , url: '/api/nnp/post_comment'
      , data: data
    } ).then(
      function( result ) {

        result.status = result.status || false;
        if ( ! result.status ) {
          showError( getLocalization( 'error__general' ) );
          return;
        }

        //if result.status is other than 'OK', we have an error from the API and show it
        if( 'ok' !== result.status ) {
          showError( result.error );
          return;
        }

        //if result.comment_approved is not set here, we have an unknown error
        result.comment_approved = result.comment_approved || false;
        if ( ! result.comment_approved ) {
          showError( getLocalization( 'error__general' ) );
          return;
        }

        //depending on comment_approved property:
        //case "1": comment approved, reload comments, done
        if ( '1' ===  result.comment_approved ) {

          const event = document.createEvent('Event');
          event.initEvent('tee_event_submitcomment', true, true);
          document.dispatchEvent(event); // for DNI

          init();
          return;
        }

        // in every other case: show moderation message, reload comments, done
        showNotification( getLocalization( 'info__commentInReviewHeader' ), false, getLocalization( 'info__commentInReviewText' ) ).always(
          function() {

            const event = document.createEvent('Event');
            event.initEvent('tee_event_submitcomment', true, true);
            document.dispatchEvent(event); // for DNI

            init();
          }
        );
      },
      function( jqXHR, textStatus, errorThrown ) {
        //failure
        console.log( 'Error posting comment: ' +  errorThrown );
        showError( getLocalization( 'error__general' ) );
        return;
      }
    ).always(
      function() {
        //always disable processing indicator when done
        processing( false );
      }
    );
  }

  function reportComment() {

    //indicate processing
    reportProcessing( true );

    //create data object for the API call
    var data = {
      comment_id: reportCommentFormWrapper.data( 'comment-parent' ) || false,
      commentcontent: reportCommentFormWrapper.data( 'comment-content' ) || false,
      reporttext: $.trim( reportTextarea.val() ),
      reason: $.trim(reportSelect.attr('data-report-slug') ),
      is_desktop: true,
    };

    //call the API
    $.ajax( {
      type: 'POST'
      , dataType: 'json'
      , url: '/api/nnp/report_comment'
      , data: data
    } ).then(
      function( result ) {
        let reportedCommentIds = getReportedCommentIds();
        // store report in local storage to prevent multiple reports
        // of the same comment by the same user
        storage.set('reported-comments', [...reportedCommentIds, data.comment_id]);

        const reportCommentButtonNode = document.querySelector('#vodl-comment__report-comment-' + data.comment_id);
        if (reportCommentButtonNode) {
          reportCommentButtonNode.classList.add('vodl-comment__report-comment--disabled');
        }

        // in every other case: show moderation message, reload comments, done
        showNotification( getLocalization( 'info__commentInReviewHeader' ), false, getLocalization( 'report__finished' ) ).always(
          function() {
            handleReportCancelClick();
            init();
            reportTextarea.val('');
            reportErrorNode.empty();
          }
        );
      },
      function( jqXHR, textStatus, errorThrown ) {
        //failure
        console.log( 'Error posting report: ' +  errorThrown );
        return;
      }
    ).always(
      function() {
        //always disable processing indicator when done
        reportProcessing( false );
        handleReportCancelClick();
      }
    );
  }

  /**
   * Load the comments and return a promise
   * @return {Promise} A promise object
   */
  function loadComments() {
    var rnd = Math.floor( ( Math.random() * 100000 ) + 1 );
    var deferred = $.Deferred()
      , url = '/api/nnp/get_rendered_forum?rnd=' + rnd + '&p=' + postId;
    ;

    $.ajax( {
      type: 'GET'
      , url: url
    } ).then(
      function( result ) {
        result.status = result.status || false; //this should be 'ok' under normal circumstances
        result.rendered = result.rendered || false; //this should contain the rendered comments
        result.error = result.error || false; //this contains error details in case of failure
        comment_registration = result.comment_registration || false; //if comment registration is required

        if ( 'ok' === result.status ) {
          //success - append the rendered comments to the commentsWrapper node
          commentsWrapper.empty();
          commentsWrapper.append( result.rendered  );
          deferred.resolve();
        } else {
          //failure, reject promise
          console.log( 'Error loading comments: ' +  result.error );
          deferred.reject();
        }
      },
      function( jqXHR, textStatus, errorThrown ) {
        //failure, reject promise
        console.log( 'Error loading comments: ' +  errorThrown );
        deferred.reject();
      }
    );

    return deferred.promise();
  }


  /* frontend functionality (notifications etc.)  */

  /**
   * Updates the rating count for a given object
   * @param  {Object} data data object returned by the rating API call
   */
  const updateRatings = ( data, type ) => {
    data.comment_id = data.comment_id || false;

    const positiveCount = commentsWrapper.find( '#vodl-comment__rating-up-' + data.comment_id )
      , positiveCountValue = parseInt(positiveCount.text()) + 1
      , negativeCount = commentsWrapper.find( '#vodl-comment__rating-down-' + data.comment_id )
      , negativeCountValue = parseInt(negativeCount.text()) + 1;

    if ( positiveCount.length > 0 && type === 'positive' ) {
      positiveCount.empty().append( positiveCountValue );
    }

    if ( negativeCount.length > 0 && type === 'negative' ) {
      negativeCount.empty().append( negativeCountValue );
    }

  };

  /**
   * disables the rating buttons for a comment with a given commentId
   * @param  {number} commentId The commentId to look for
   * @return {boolean}          true on success, otherwise false
   */
  function disableRatingButtons( commentId ) {
    commentId = commentId || false;
    if( ! commentId ) {
      return false;
    }

    var disabledCSS = {
      'opacity': '.5',
      'cursor': 'not-allowed'
    };

    var ratePositiveIcon = commentsWrapper.find( ".vodl-comment__rating-up-icon[data-comment-id='" + commentId + "']" );
    if ( ratePositiveIcon.length > 0 ) {
      ratePositiveIcon.off( 'click' ).css( disabledCSS );
    }

    var rateNegativeIcon = commentsWrapper.find( ".vodl-comment__rating-down-icon[data-comment-id='" + commentId + "']" );
    if ( rateNegativeIcon.length > 0 ) {
      rateNegativeIcon.off( 'click' ).css( disabledCSS );
    }

    return true;
  }

  /**
   * Updates the number of characters left in the textarea
   */
  function updateCharCount() {
    var count = textarea.val().length;
    count = 1000 - count;
    charCounter.empty().append( count );
  }

  /**
   * Display an error messsage below the form
   * @param  {string} message the message to be displayed to the user
   */
  function showError( message ) {
    errorNode.empty().append( message );
  }
  function showReportError( message ) {
    reportErrorNode.empty().append( message );
  }

  /**
   * Show a notification modal to the user
   * @param  {string} header Header text
   * @param  {string} title  Title text
   * @param  {string} text   Notification text
   * @return {Promise}       A promise object
   */
  function showNotification(header, title, text) {
    var deferred = $.Deferred()
      , notificationModal = $('.vodl-notification--modal')
      , notificationHeader = false
      , notificationTitle = false
      , notificationText = false
      , notificationBody = false
      , notification = false
        ;
    header = header || '';
    title = title || '';
    text = text || '';

    if (0 === notificationModal.length) {
      deferred.reject();
      return deferred.promise();
    }

    // we assume now the other nodes are there if the modal node is available.
    notificationHeader = notificationModal.find('.vodl-notification__header-text');
    notificationTitle = notificationModal.find('.vodl-notification__title');
    notificationText = notificationModal.find('.vodl-notification__text');

    // empty all nodes first
    notificationHeader.add(notificationTitle).add(notificationText).empty();

    // set the given values
    notificationHeader.append(header);
    notificationTitle.append(title);
    notificationText.append(text);

    if (premiumContent) {
      notification = notificationModal.find('.vodl-notification');
      notificationBody = notificationModal.find('.vodl-notification__body');
      let notificationButton = notificationModal.find('.vodl-notification__button');

      if (0 === notificationButton.length) {
        notificationBody.append('<div class="vodl-notification__button"><button class="vodl-button vodl-button--red" type="button"><span class="vodl-button__label">OK</span></button></div>');
      }

      notification.addClass('vodl-notification--vplus');
    }

    // show the modal
    notificationModal.css('display', 'flex');
    notificationModal.find('.vodl-notification__header').addClass('vodl-notification__header--show');
    deferred.resolve();

    return deferred.promise();
  }

  /**
   * Indicates processing by disabling form elements and triggering an animation on top of the comment form.
   * @param  {Boolean} isProcessing True to indicate processing, false to remove the indication
   */
  function processing( isProcessing ) {

    isProcessing = isProcessing || false;

    var loadingIndicator = commentFormWrapper.find( '.vodl-comment-section__loading' );

    if ( isProcessing ) {
      //disable all forrm elements
      textarea.prop( 'disabled', true );
      submitButton.prop( 'disabled', true );
      usernameInput.prop( 'disabled', true );
      //show the animation
      loadingIndicator.show();
    } else {
      //re-enable all forrm elements
      textarea.prop( 'disabled', false );
      submitButton.prop( 'disabled', false );
      usernameInput.prop( 'disabled', false );
      //hide the animation
      loadingIndicator.hide();
    }
  }

  function reportProcessing( isProcessing ) {

    isProcessing = isProcessing || false;

    if ( isProcessing ) {
      //disable all form elements
      reportSelect.prop( 'disabled', true );
      reportTextarea.prop( 'disabled', true );
      submitReportButton.prop( 'disabled', true );
    } else {
      //re-enable all form elements

      reportSelect.prop( 'disabled', false );
      reportTextarea.prop( 'disabled', false );
      submitReportButton.prop( 'disabled', false );
    }
  }

  function localStorageAddComment() {

    localStorageComment = localStorage.getItem( 'comment_data' );
    const comment_data  = JSON.parse( localStorageComment );

    if ( comment_data && comment_data.comment_post_id == postId ) {
      let element_id = 'comments';
      textarea.val( comment_data.comment_content );
      updateCharCount();
      if ( comment_data.comment_parent ) {
        element_id = 'vodl-comment__answer-comment-'+comment_data.comment_parent;
        $('#'+element_id).trigger( "click" );
      }
      document.getElementById(element_id).scrollIntoView();
    }
  }

  function moveCommentAds() {
    //@TODO: move ads into their correct postion
  }

  function filterComments() {
    //@TODO: filter comments based on user preferences
  }

  function trackClick() {
    trackGA();
    trackOewa();
  }

  function trackGTMComments() {
    if ( typeof dataLayer !== 'undefined' && typeof gtm_tracking_enable !== 'undefined' && true === gtm_tracking_enable ) {

      let numberOfComments = document.querySelectorAll('.vodl-comment').length;

      // grab the article title from og:title meta.
      let articleTitleNode = document.querySelector('meta[property="og:title"][content]');
      let articleTitle = articleTitleNode ? articleTitleNode.attributes['content'].value : null;

      // fallback to the title tag
      if (!articleTitle) {
        articleTitleNode = document.querySelector('title');
        articleTitle = articleTitleNode ? articleTitleNode.innerHTML : 'unknown article title';
      }

      const eventData = {
        event: 'genericEvent',
        eventCategory: 'Comment',
        eventAction: articleTitle,
        eventLabel: numberOfComments,
        metric41: 1,
      };
  
      dataLayer.push(eventData);
  
      document.dispatchEvent(
        new CustomEvent('hansrmdtevent', { detail: eventData })
      );
    }
  }

  function trackGA() {
    if (typeof _rm_gua === "undefined") {
      return;
    }

    let uaPagePath = window.location.pathname + "/";

    _rm_gua("set", "dimension4", 'Comment rated');
    _rm_gua("send", "pageview", uaPagePath);

    return;
  }

  function trackOewa() {
    if (typeof oewa_data === 'undefined') {
      return;
    }

    if (typeof window.IOMm !== 'undefined') {
      window.IOMm('pageview', { cp: oewa_data['cp'] });
    }
  }

  //add User banned from commenting message and hide comment section
  function hideCommentSection(commentBan) {
    const bannedMessage =
      commentBan.status === 'temp' && commentBan.date
      ? `Dein Account wurde aufgrund eines Verstoßes gegen unsere <a target="_blank" href="/features/netiquette">Netiquette</a> bis zum ${commentBan.date} gesperrt.`
      : 'Dein Account wurde aufgrund eines schweren Verstoßes gegen unsere <a target="_blank" href="/features/netiquette">Netiquette</a> permanent gesperrt.';

    const informationMessage = ' Bei Fragen zu deiner Sperrung wende dich bitte an <a href="mailto:redaktion@vol.at">redaktion@vol.at</a>';

    const newDivElement = document.createElement('div');
    newDivElement.innerHTML = bannedMessage + informationMessage;
    newDivElement.classList.add('vodl-comment-section__user-comment-ban');
    document.querySelector('.vodl-comment-section__headline').parentNode.appendChild(newDivElement);

    document.querySelector('.vodl-comment-section__form-wrapper').style.display = 'none';
  }

  //init immediately
  init();

} )( window, document );
